/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Contact_EmailInputs */



/**
* | output |
* | --- |
* | "Contact email" |
*
* @param {Profile_Contact_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_contact_email = /** @type {((inputs?: Profile_Contact_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Contact_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email de contact")
	if (locale === "es") return /** @type {LocalizedString} */ ("Email de contacto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Email de contato")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email di contatto")
	return /** @type {LocalizedString} */ ("Contact email")
});